import { createAction, createAsyncAction } from 'typesafe-actions'
import { ReadBalanceRequestDto, TradingBalanceResponseDto, WsEvent, WsEventType } from '@sparling/financial-common'

export const {
  request: getBalancesRequest,
  success: getBalancesSuccess,
  failure: getBalancesFailure,
} = createAsyncAction('GET_BALANCES_REQUEST', 'GET_BALANCES_SUCCESS', 'GET_BALANCES_FAILURE')<
  ReadBalanceRequestDto & { token: string },
  TradingBalanceResponseDto[],
  Error
>()

export const userBalanceUpdated =
  createAction('USER_BALANCE_UPDATED')<WsEvent<WsEventType.USER_BALANCE_UPDATED>['payload']>()
